import React, { useState } from 'react';
import Icon from '../../Icon/Icon';

import Link, { LinkAdapter } from '../../Link/Link';
import ModalDialog from '../../ModalDialog/ModalDialog';

import styles from './Cart.module.scss';

export type CartProps = {
  /** Link where user is redirected after clicking on the cart */
  link: string;
  /** Number of items in cart */
  amount?: number;
  /** Aria label for the cart link */
  linkAriaLabel: string;
  /** Custom link or for injecting third party routing link */
  linkAdapter?: LinkAdapter;
  /** Opens a Modal on Clicking cart icon */
  openModalPopup?: boolean;
  /** Content of the Modal popup */
  ModalContent?: string;
  /** Title of the Modal popup */
  ModalTitle?: string;
};

const Cart: React.FunctionComponent<CartProps> = ({
  link,
  amount,
  linkAriaLabel,
  linkAdapter,
  openModalPopup = false,
  ModalContent,
  ModalTitle,
}) => {
  const title =
    ModalTitle ?? 'Ostoskorissasi on tuotteita molemmista verkkokaupoistamme';
  const [openModal, setOpenModal] = useState(false);
  const modalContentAsHTML = ModalContent ?? '';

  const openModalOnClick = () => {
    setOpenModal(true);
    return;
  };

  const closeModalOnClick = () => {
    setOpenModal(false);
    return;
  };
  // eslint-disable-next-line no-constant-condition
  return openModalPopup ? (
    <>
      <ModalDialog
        isOpen={openModal}
        data-testid="shoppingCartModal"
        title={title}
        onCloseClick={closeModalOnClick}
      >
        <div dangerouslySetInnerHTML={{ __html: modalContentAsHTML }} />
      </ModalDialog>
      <Link
        className={styles.cart}
        aria-label={linkAriaLabel}
        linkAdapter={linkAdapter}
      >
        <Icon
          data-testid="shoppingCartIconWithModal"
          name="cart"
          size="lg"
          color="black"
          onClick={openModalOnClick}
        />
        <div className={styles.cart_amount} onClick={openModalOnClick}>
          <Icon
            name="pebble"
            size="md"
            color="purple500"
            className={styles.cart_amount}
          />
          <div className={styles.cart_amountNumber}>{amount}</div>
        </div>
      </Link>
    </>
  ) : (
    <Link
      className={styles.cart}
      to={link}
      aria-label={linkAriaLabel}
      linkAdapter={linkAdapter}
    >
      <Icon name="cart" size="lg" color="black" />
      {amount && amount > 0 ? (
        <div className={styles.cart_amount}>
          <Icon
            name="pebble"
            size="md"
            color="purple500"
            className={styles.cart_amount}
          />
          <div className={styles.cart_amountNumber}>{amount}</div>
        </div>
      ) : null}
    </Link>
  );
};

export default Cart;
